import { useState, useCallback } from 'react';

export type menuCollapsed = boolean;

// 默认展开所有1级菜单
const defaultOpenKeys = [
  '/data-center',
  '/order-center',
  '/order-config',
  '/company-manage',
  '/organization',
  '/finance-manage',
];
export default function Menu() {
  const [collapsed, setCollapsed] = useState<menuCollapsed>(false);
  const [openKeys, setOpenKeys] = useState<any[]>(defaultOpenKeys);

  const setCollapsedM = useCallback((val) => {
    setCollapsed(val);
  }, []);
  const setOpenKeysCb = useCallback((val) => {
    setOpenKeys(val);
  }, []);
  return {
    collapsed,
    setCollapsedM,
    defaultOpenKeys,
    openKeys,
    setOpenKeysCb,
  };
}
